import { action, makeObservable, observable } from 'mobx';
import { List } from 'react-virtualized';
import type { RootStore } from 'logic';

export class UiQueueScrollStore {
  private rootStore: RootStore;
  listRef: List | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      listRef: observable,
      setList: action.bound,
      scrollToTop: action.bound,
      scrollToEnd: action.bound,
      scrollToCard: action.bound,
    });
  }

  setList(ref: List | null) {
    this.listRef = ref;
  }

  scrollToTop() {
    this.listRef?.scrollToRow(0);
  }

  scrollToEnd() {
    this.listRef?.scrollToRow(-1);
  }

  scrollToCard(cardId: string) {
    const currentSession = this.rootStore.sessionsStore.currentSession;
    if (!currentSession) return;

    const cardIndex = currentSession.inProgressVisibleCardIds.findIndex((id) => id === cardId);
    if (cardIndex !== -1) {
      this.listRef?.scrollToRow(cardIndex);
    }
  }
}
